import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import { Layout, Form, Icon, Input, Button, Divider } from 'antd'
import authService from '../services/authentication.service'
import joinusService from '../services/joinus.service'
import { UserContext } from '../contexts/UserContext'

const { Header } = Layout

class JoinUsRegistrationForm extends React.Component {
  state = {
    isLoggedIn: false,
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        console.log('Received values of form: ', values)
        const registered = await authService.registerJoinUsUser(
          values.username,
          values.password,
          values.confirmPassword
        )

        await joinusService.saveRecruitment({ email: values.username })

        if (registered) {
          console.log('registered...', registered)
          this.context.setJoinUsUser({ email: values.username })
          this.setState({ isLoggedIn: true })
        }
      }
    })
  }

  render() {
    const { isLoggedIn } = this.state
    const { getFieldDecorator } = this.props.form

    if (isLoggedIn) return <Redirect to="/joinus" />

    return (
      <Form onSubmit={this.handleSubmit} className="login-form register-form">
        <Form.Item>
          {getFieldDecorator('username', {
            rules: [{ required: true, message: 'Please input your username!' }],
          })(
            <Input
              prefix={<Icon type="user" style={{ color: '#FFF' }} />}
              placeholder="Username"
              style={{ marginTop: '-5rem' }}
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Please input your Password!' }],
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: '#FFF' }} />}
              type="password"
              placeholder="Password"
              style={{ marginTop: '-5rem' }}
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('confirmPassword', {
            rules: [
              { required: true, message: 'Please confirm your Password!' },
            ],
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: '#FFF' }} />}
              type="password"
              placeholder="Confirm Password"
              style={{ marginTop: '-5rem' }}
            />
          )}
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            size="large"
            shape="round"
            block={true}
            htmlType="submit"
            className="login-form-button"
            style={{ marginTop: '-6rem' }}
          >
            Register
          </Button>
          <Link to="/joinus/login">
            <p className="cta-link">Already have an account? Sign in</p>
          </Link>
        </Form.Item>
      </Form>
    )
  }
}

const WrappedJoinUsRegistrationForm = Form.create({
  name: 'joinus_registration',
})(JoinUsRegistrationForm)

const JoinUsRegistration = () => {
  return (
    <Layout>
      <section id="login-page">
        <Header className="header">
          <div className="header__logo" />
        </Header>
        <content>
          <section id="login-content">
            <div className="cta">
              <h1>
                Inspire Innovative Approaches for<br></br>Positive Change
              </h1>
              <h3>Survey, Evaluation, Third Party Monitoring</h3>
            </div>
            <Divider type="vertical" />
            <div className="login-form-container registration-form-container">
              <WrappedJoinUsRegistrationForm />
            </div>
          </section>
        </content>
      </section>
    </Layout>
  )
}

JoinUsRegistrationForm.contextType = UserContext

export default JoinUsRegistration
